"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _reduxForm = require("redux-form");
var _ThemeSettingsComponent = _interopRequireDefault(require("./ThemeSettingsComponent"));
var _config = _interopRequireDefault(require("../../../../../config"));
var _ChartEnums = require("./ChartEnums");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var ThemeForm = (0, _reduxForm.reduxForm)({
  form: 'themeForm',
  enableReinitialize: true,
  onSubmit: function onSubmit() {}
})(_ThemeSettingsComponent["default"]);
var mapStateToProps = function mapStateToProps(state, _ref) {
  var themeOptions = _ref.themeOptions;
  var theme = _config["default"].global.theme;
  var chart = _config["default"].TradingLayout.chart;
  var localConfig = JSON.parse(localStorage.getItem('apexTemplate')) || {};
  var currentTheme = localConfig.theme || theme;
  var currentChart = localConfig.chart || chart;
  return {
    initialValues: {
      theme: currentTheme.charAt(0).toUpperCase() + currentTheme.slice(1),
      chart: currentChart
    },
    formValues: (0, _reduxForm.getFormValues)('themeForm')(state) || {},
    themeOptions: themeOptions
  };
};
var ThemeSettingsContainer = (0, _reactRedux.connect)(mapStateToProps)(ThemeForm);
var _default = exports["default"] = ThemeSettingsContainer;